module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('ul', {
    staticClass: "user-list"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.selectVoucher()
      }
    }
  }, [_c('span', [_vm._v("选择就诊人")])]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "form-right gwi-ipt my-ipt",
    attrs: {
      "id": "voucherAdd-input-userName",
      "type": "text",
      "placeholder": "请输入姓名",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardNo),
      expression: "cardNo"
    }],
    staticClass: "form-right gwi-ipt my-ipt",
    attrs: {
      "id": "voucherAdd-input-cardNo",
      "type": "text",
      "placeholder": "请输入就诊人身份证号码",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.cardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardNo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ok-wrap"
  }, [_c('button', {
    staticClass: "btn-ok",
    attrs: {
      "id": "feedback-submit",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("确认")])]), _vm._v(" "), _c('half-window', {
    attrs: {
      "data-list": _vm.voucherList
    },
    model: {
      value: (_vm.showWindow),
      callback: function($$v) {
        _vm.showWindow = $$v
      },
      expression: "showWindow"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "f-strong"
  }, [_vm._v("选择就诊人")])]), _vm._v(" "), _c('ul', {
    staticClass: "list",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.voucherList), function(item) {
    return _c('li', {
      staticClass: "list-item",
      class: 'arr-item-blue',
      on: {
        "click": function($event) {
          return _vm.selectUser(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.holderName) + "/" + _vm._s(_vm._f("dotted")(item.cardNo)))])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75401ed9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/hospitalPage/HealthySichuanMyRegister.vue
// module id = 855
// module chunks = 0